import reactUpdate from 'immutability-helper';
import * as PropTypes from 'prop-types';
import React from 'react';

import {SchemaTag} from 'folder-items/FileConstants';
import * as BlobActions from 'schemas/tags/BlobActions';
import {BenchlingBlob} from 'schemas/tags/BlobConstants';
import BlobInputModal from 'schemas/tags/BlobInputModal';
import FormInput from 'ui-library/bs/FormInput';
import Chip, {ChipSize} from 'ui-library/chips/Chip';
import ModalAnchor from 'ui-library/ModalAnchor';

export interface BlobLinkInputProps {
  defaultValue: SchemaTag;
  onChange({targetBlobs, value}: {targetBlobs: Array<BenchlingBlob>; value: string}): void;
  placeholder?: string;
}

interface State {
  isModalOpen: boolean;
}

export default class BlobLinkInput extends React.Component<BlobLinkInputProps, State> {
  static propTypes = {
    defaultValue: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired,
    placeholder: PropTypes.string,
  };

  state: State = {
    isModalOpen: false,
  };

  _getBlobs(): Array<BenchlingBlob> {
    return this.props.defaultValue.targetBlobs || [];
  }

  _canAddMoreBlobs(): boolean {
    return this.props.defaultValue.tagSchemaField.isMulti || this._getBlobs().length === 0;
  }

  _handleChangeBlobs(blobs: Array<BenchlingBlob>): void {
    this.props.onChange({targetBlobs: blobs, value: blobs.map((blob) => blob.name).join(', ')});
  }

  _handleAddBlobs(newBlobs: Array<BenchlingBlob>): void {
    this._handleChangeBlobs([...this._getBlobs(), ...newBlobs]);
  }

  _removeBlobAtIndex(index: number): void {
    const newBlobs = reactUpdate(this._getBlobs(), {$splice: [[index, 1]]});
    this._handleChangeBlobs(newBlobs);
  }

  render(): JSX.Element {
    const blobs = this._getBlobs();
    return (
      <div className="chipSelectInput chipLinkInput">
        {blobs.map((blob, index) => (
          <Chip
            key={index}
            className="chip-container"
            size={ChipSize.SMALL}
            text={blob.name}
            onRemove={(e) => {
              this._removeBlobAtIndex(index);
            }}
          />
        ))}
        {this._canAddMoreBlobs() && (
          <div>
            {this.state.isModalOpen && (
              <ModalAnchor open={true}>
                <BlobInputModal
                  allowMultiple={this.props.defaultValue.tagSchemaField.isMulti}
                  onRequestClose={() => {
                    this.setState({isModalOpen: false});
                  }}
                  onUploadFiles={(files) =>
                    BlobActions.uploadFilesAsBlobs(files, {
                      shouldGeneratePreviewFile: true,
                      onBlobsCreated: (newBlobs) => {
                        this._handleAddBlobs(newBlobs);
                      },
                    })
                  }
                />
              </ModalAnchor>
            )}
            <FormInput
              // Don't autofocus. That will open the modal, and that's too disruptive
              autoFocus={false}
              className="chipSelectInput-input u-flex-grow"
              onFocus={() => {
                this.setState({isModalOpen: true});
              }}
              placeholder={this.props.placeholder ?? 'Upload File'}
              type="text"
              value=""
              onChange={() => {}}
              readOnly={false}
            />
          </div>
        )}
      </div>
    );
  }
}
